import React from "react"
import { DataUploadNotification } from "./dataUploadNotification"

export const GlobalNotifications = () => (
    <>
        <DataUploadNotification />
    </>
)
